import { type ApiResponse, type SalesforceReport, type SalesforceContactsProps, type SalesforceLists } from '@types';
import { syncApi } from '@lib/apiClients.ts';
import { microServicesRoutes } from '@constants';
interface useSalesforceSyncApiReturn {
  getSalesforceLists: (
    userId: string,
    organizationId: string
  )=> Promise<ApiResponse<SalesforceLists[]>>
  getSalesforceReports: (
    folderName: string,
    organizationId: string,
    userId: string,
    nonce: string,
  )=> Promise<ApiResponse<SalesforceReport[]>>

  getSalesforceContacts: (
    organizationId: string,
    userId: string,
    nonce: string,
    listId: string,
  )=> Promise<ApiResponse<SalesforceContactsProps>>

  searchSalesforceObjects: (
      userId: string,
      orgId: string,
      search?: string
  )=> Promise<ApiResponse<SalesforceLists[]>>

}

export function useSalesforceSyncApi (): useSalesforceSyncApiReturn {
  async function searchSalesforceObjects (
    userId: string,
    orgId: string,
    search?: string
  ): Promise<ApiResponse<SalesforceLists[]>> {
    try {
      let url = `${microServicesRoutes.sync.get.salesforce.getLists}/${orgId}/${userId}`;

      if (search !== undefined) {
        url += `?search=${encodeURIComponent(search)}`;
      }

      const { data } = await syncApi.get<SalesforceLists[]>(url);

      return { data, success: true };
    } catch (error: unknown) {
      return { error: { message: 
              'Error while getting salesforce objects.',
      }, success:false };
    }
  }

  async function getSalesforceLists (
    userId: string,
    organizationId: string
  ): Promise<ApiResponse<SalesforceLists[]>> {
    try {
      const url = `${microServicesRoutes.sync.get.salesforce.getLists}/${organizationId}/${userId}`;
      const { data } = await syncApi.get<SalesforceLists[]>(url);

      return { data, success: true };
    } catch (error: unknown) {
      return { error: { message:
        'Error while getting Salesforce Lists.' }, success: false };
    }
  }

  async function getSalesforceReports (
    folderName: string,
    organizationId: string,
    userId: string,
    nonce: string,
  ): Promise<ApiResponse<SalesforceReport[]>> {
    try {
      const url = `${microServicesRoutes.sync.get.salesforce.getReport}/${folderName}/${organizationId}/${userId}/${nonce}`;
      const { data } = await syncApi.get<SalesforceReport[]>(url);

      return { data, success: true };
    } catch (error: unknown) {
      return { error: { message: 
              'Error while getting salesforce reports.' }
      , success: false };
    }
  }

  async function getSalesforceContacts (
    organizationId: string,
    userId: string,
    nonce: string,
    listId: string,
  ): Promise<ApiResponse<SalesforceContactsProps>> {
    try {
      const url = `${microServicesRoutes.sync.get.salesforce.getContacts}/${organizationId}/${userId}/${nonce}/${listId}`;
      const { data } = await syncApi.get<SalesforceContactsProps>(url);

      return { data, success: true };
    } catch (error: unknown) {
      return { error: { message: 
              'Error getting Salesforce contacts' 
      }, success: false };
    }
  }

  return {
    searchSalesforceObjects,
    getSalesforceLists,
    getSalesforceReports,
    getSalesforceContacts
  };
}